import { useLayoutEffect, useState } from 'react'
import { ContentModal } from 'components/organisms/modals/content-modal'
import { IconSvg, PdfPreview } from 'components/common'

interface PolicyPdfModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	policyFileUrl?: string | null
	title?: string | null
}

export function PolicyPdfModal({ open, setOpen, policyFileUrl, title }: PolicyPdfModalProps) {
	const [pdfWidth, setPdfWidth] = useState<number>(680)

	useLayoutEffect(() => {
		function updateSize() {
			if (window.innerWidth < 640) {
				setPdfWidth(window.innerWidth - 16)
			} else {
				setPdfWidth(Math.min(680, window.innerWidth - 80))
			}
		}
		window.addEventListener('resize', updateSize)
		updateSize()
		return () => window.removeEventListener('resize', updateSize)
	}, [])

	return (
		<ContentModal
			open={open}
			setOpen={setOpen}
			size="2xl"
			title={
				<span className="flex items-center justify-center gap-2">
					<IconSvg icon="user" aria-hidden="true" />
					{title || 'Opt-in Policy'}
				</span>
			}
			className="!px-0 sm:!px-8"
		>
			{policyFileUrl && (
				<div className="flex justify-center h-[62vh] overflow-hidden">
					<PdfPreview
						file={`${import.meta.env.VITE_MEDIA_URL}/${policyFileUrl}`}
						width={pdfWidth}
						className="h-full"
					/>
				</div>
			)}
		</ContentModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface PolicyPdfModalManagedProps {
	policyFileUrl?: string | null
	title?: string | null
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'policy-pdf': PolicyPdfModalManagedProps
	}
}

export function ManagedPolicyPdfModal({
	onClose,
	...rest
}: PolicyPdfModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<PolicyPdfModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			{...rest}
		/>
	)
}
